import { Routes } from '@angular/router';

/**
 * Routing für das Hilfe-Center.
 *
 *   /hilfe                       → Rollenwahl (eingeloggt: Hinweis-Banner,
 *                                  trotzdem Wahl-UI nach OnePager § 14.2)
 *   /hilfe/kunden                → Übersicht aller Kunden-FAQs
 *   /hilfe/kunden/:slug          → Einzel-Artikel (deeplinkbar)
 *   /hilfe/handwerker            → Übersicht aller Handwerker-FAQs
 *   /hilfe/handwerker/:slug      → Einzel-Artikel
 *
 * Alle Komponenten standalone und lazy.
 */
export const hilfeRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./hilfe-rollenwahl/hilfe-rollenwahl.component').then(
        (m) => m.HilfeRollenwahlComponent,
      ),
  },
  {
    path: 'kunden',
    loadComponent: () =>
      import('./hilfe-uebersicht/hilfe-uebersicht.component').then(
        (m) => m.HilfeUebersichtComponent,
      ),
    data: { audience: 'kunden' },
  },
  {
    path: 'kunden/:slug',
    loadComponent: () =>
      import('./hilfe-artikel/hilfe-artikel.component').then(
        (m) => m.HilfeArtikelComponent,
      ),
    data: { audience: 'kunden' },
  },
  {
    path: 'handwerker',
    loadComponent: () =>
      import('./hilfe-uebersicht/hilfe-uebersicht.component').then(
        (m) => m.HilfeUebersichtComponent,
      ),
    data: { audience: 'handwerker' },
  },
  {
    path: 'handwerker/:slug',
    loadComponent: () =>
      import('./hilfe-artikel/hilfe-artikel.component').then(
        (m) => m.HilfeArtikelComponent,
      ),
    data: { audience: 'handwerker' },
  },
];
